import { render, staticRenderFns } from "./PianiWelfare.vue?vue&type=template&id=7288886a&scoped=true"
import script from "./PianiWelfare.vue?vue&type=script&lang=js"
export * from "./PianiWelfare.vue?vue&type=script&lang=js"
import style0 from "./PianiWelfare.vue?vue&type=style&index=0&id=7288886a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7288886a",
  null
  
)

export default component.exports